import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import componentWithSyncWrapper from 'src/components/containers/common/component-with-sync-wrapper';
import { connect } from 'react-redux';

import * as synonymActions from 'src/stores/actions/synonym-actions';
import ConfirmRemoveModal from './confirm-remove-modal';
import { SynonymType } from 'src/constants/synonym';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';

const DeleteSynonymModal = props => {
  const {
    i18n,
    open,
    synonymIds,
    synonymType,
    onClose,
    reload,
    deleteSynonyms,
    deleteAISynonyms,
    synonyms
  } = props;
  const [deleting, setDeleting] = React.useState(false);

  const onDelete = async () => {
    setDeleting(true);
    if (synonymType === SynonymType.MANUAL) {
      await deleteSynonyms(synonymIds);
    } else {
      //Tracking event
      const deleteSynonym = synonyms.find(e => e._id === synonymIds[0]);
      mixpanelV3Helper.trackEventData('Delete AI Synonym', {
        feature: 'Synonym',
        synonymType: 'AI',
        confidenceScore: Math.round(deleteSynonym?.confidence * 100)
      });

      await deleteAISynonyms(synonymIds[0]);
    }
    setDeleting(false);
    reload();
    onClose();
  };

  return (
    <ConfirmRemoveModal
      active={open}
      handleChange={onClose}
      handleRemove={onDelete}
      title={i18n.translate('AdminHTML.Synonym.Edit.deleteSelected')}
      content={i18n.translate('AdminHTML.Synonym.Edit.confirmDelete')}
      deleting={deleting}
    />
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  deleteSynonyms: termIds => dispatch(synonymActions.deleteSynonyms(termIds, ownProps.i18n)),
  deleteAISynonyms: synonymId => dispatch(synonymActions.deleteAISynonyms(synonymId, ownProps.i18n))
});

export default componentWithSyncWrapper(
  withI18n()(connect(null, mapDispatchToProps)(DeleteSynonymModal)),
  'ManualSynonymSetting'
);
